<template>
    <tags-input 
        ref="tagInput" 
        v-model="tags" 
        :existing-tags="computedExistingTags" 
        text-field="label" 
        id-field="key"
        :typeahead="true" 
        :typeahead-show-on-focus="true"  
        :placeholder="placeholder" 
        :before-adding-tag="beforeAddingTag"
        @tag-removed="onTagRemoved" 
    />
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            required: false,
            default: () => [],
        },
        departments: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: 'Add departments...',
        },
    },

    mounted() {
        this.$on('reset', this.reset);
    },

    beforeDestroy() {
        this.$off('reset');
    },

    data() {
        return {
            tags: [...this.value], // Holds the current tags
            existingTagIds: new Set(), // Set to track existing tag IDs (bypass beforeAddingTag duplicate check)
        };
    },

    watch: {
        tags: {
            handler(newTags) {
                if (JSON.stringify(newTags) !== JSON.stringify(this.value)) {
                    this.$emit('input', newTags);
                }
            },
            deep: true,
        },

        value: {
            handler(newValue) {
                if (JSON.stringify(newValue) !== JSON.stringify(this.tags)) {
                    this.tags = [...newValue];
                    // Populate existingTagIds Set with tag IDs from value
                    this.existingTagIds = new Set(newValue.map(tag => tag.key));
                }
            },
            deep: true,
        },
    },

    computed: {
        computedExistingTags() {
            const existingTagKeys = new Set(this.tags.map(tag => tag.key));
            return this.departments
                .map(department => ({
                    label: this.labelizeGeneral(department.name),
                    key: department.id,
                }))
                .filter(tag => !existingTagKeys.has(tag.key));
        },
    },

    methods: {
        beforeAddingTag(tag) {
            // If the tag exists in the existingTagIds Set, bypass the duplicate check.
            // This is necessary during editing mode when the case already has departments 
            // to avoid marking them as duplicates unnecessarily.
            if (this.existingTagIds.has(tag.key)) {
                this.existingTagIds.delete(tag.key);
                return true;
            }

            const departmentExists = this.departments.some(
                department => department.id === tag.key
            );

            if (!departmentExists) {
                this.$emit('message', 'Please choose an existing department', 'danger');
                return false;
            }

            if (this.tags.some(existingTag => existingTag.key === tag.key)) {
                this.$emit('message', 'Duplicate department name', 'danger');
                return false;
            }

            return true;
        },

        onTagRemoved(tag) {
            this.$emit('tag-removed', tag);
        },

        reset() {
            this.tags = [];
            this.existingTagIds.clear();
            if (this.$refs.tagInput) {
                this.$refs.tagInput.input = '';
                this.$refs.tagInput.oldInput = '';
            }
        },
    },
};
</script>

